export default "__VITE_ASSET__FzS00Lju__"